import { Grid2 } from "components";
import FormInputs from "./FormInputs";

const Basket = () => {
  return (
    <Grid2 container size={12}>
      <Grid2 size={3} p={3} borderRight={"1px solid var(--neutral-100)"}>
        <FormInputs />
      </Grid2>
    </Grid2>
  );
};

export default Basket;
